<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <right-cp />
        <right-xm />
        <right-yz />
      </div>
    </v-drawer>
  </div>
</template>

<script>
import rightCp from "./rightBar/rightCp";
import rightXm from "./rightBar/rightXm";
import rightYz from "./rightBar/rightYz";
export default {
  components: { rightCp, rightXm, rightYz },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
@media (min-height 1400px)
  .rightBar
    >>>.side
      width 24% !important
</style>
